<div class="d-flex" [attr.data-uit]="'file-item-' + index">
    <div class="d-flex align-items-center flex-grow-1" (click)="openItem(item, $event)">
        <ca-icon [name]="isFolder ? 'folder' : 'file'" size="s" class="me-2"></ca-icon>
        <div [ngClass]="textClasses" [caTruncate]="truncateFileNameAtWidthOf">
            <span
                [ngClass]="{
                    link: truncateFileNameAtWidthOf == null,
                    name: actions.includes('view') && (isFolder || isSupportedByArivis(item) || isSupportedByFilePreviewer(item.type)),
                }"
                data-uit="file-name"
                class="text-truncate"
                ngbTooltip="{{ item.title }}"
                placement="bottom-start"
            >
                {{ item.title }}
            </span>
        </div>
    </div>
    <ng-content></ng-content>
</div>
